export const getThumbnailSrc = (originalSrc: string) => {
  if (!originalSrc) return '';
  const parts = originalSrc.split('/');
  const fileName = parts.pop(); // Lấy tên file
  return [...parts, 'thumbnails', fileName].join('/'); // Chèn 'thumbnails' vào trước tên file
};
